import {
  fetchCollectionProduct,
  fetchCollections,
  fetchSortedCollectionProduct,
} from "src/services/CollectionApi";

export const loadCollections = async (setCollections) => {
  try {
    const collectionsData = await fetchCollections();

    // Format collections data for the slider
    const formattedCollections = collectionsData.map((collection) => ({
      ...collection,
      imageUrl: collection?.image
    }));

    setCollections(formattedCollections);
  } catch (error) {
    console.error("Failed to fetch collections:", error);
  }
};

export const fetchAndSetProductByCollectionID = async (
  collectionID,
  setcollectionProducts
) => {
  const fetchedProducts = await fetchCollectionProduct(collectionID);
  setcollectionProducts(fetchedProducts);
};

export const sortCollectionsProduct = async (
  sortOption,
  collectionID,
  setcollectionProducts,
  setLoading,
  searchParams
) => {
  setLoading(true);
  const minPrice = searchParams?.get("minPrice");
  const maxPrice = searchParams?.get("maxPrice");
  const inStock = searchParams?.get("inStock") === "true";
  const outOfStock = searchParams?.get("outOfStock") === "true";
  const categories = searchParams?.getAll("category");
  const fetchedProducts = await fetchSortedCollectionProduct(  sortOption, collectionID, minPrice,
    maxPrice,
    inStock,
    outOfStock,
    categories);
  setcollectionProducts(fetchedProducts);
  setLoading(false)
};
